"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventIndex = (function () {
    function EventIndex(events) {
        this.events = [];
        this.byPosition = {};
        this.byX = {};
        this.byY = {};
        this.removedPolygonIds = {};
        this.touchedPolygonIds = {};
        this.touchTable = {};
        this.events = events;
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
            var key = event_1.position.join(",");
            if (key in this.byPosition) {
                this.byPosition[key].push(event_1);
            }
            else {
                this.byPosition[key] = [event_1];
            }
            if (event_1.position[0] in this.byX) {
                this.byX[event_1.position[0]].push(event_1);
            }
            else {
                this.byX[event_1.position[0]] = [event_1];
            }
            if (event_1.position[1] in this.byY) {
                this.byY[event_1.position[1]].push(event_1);
            }
            else {
                this.byY[event_1.position[1]] = [event_1];
            }
        }
        for (var _a = 0, events_2 = events; _a < events_2.length; _a++) {
            var event_2 = events_2[_a];
            if (!(event_2.polygonId in this.touchTable)) {
                this.touchTable[event_2.polygonId] = {};
            }
            var overlapping = this.getByPosition(event_2.position);
            for (var _b = 0, overlapping_1 = overlapping; _b < overlapping_1.length; _b++) {
                var e = overlapping_1[_b];
                this.touchTable[event_2.polygonId][e.polygonId] = true;
            }
        }
    }
    EventIndex.prototype.getByPosition = function (position) {
        var _this = this;
        return this.byPosition[position.join(",")].filter(function (e) { return !_this.removedPolygonIds[e.polygonId]; });
    };
    EventIndex.prototype.getByX = function (position) {
        var _this = this;
        return this.byX[position[0]].filter(function (e) { return !_this.removedPolygonIds[e.polygonId]; });
    };
    EventIndex.prototype.getByY = function (position) {
        var _this = this;
        return this.byY[position[1]].filter(function (e) { return !_this.removedPolygonIds[e.polygonId]; });
    };
    EventIndex.prototype.getNextExteriorRing = function () {
        var exteriorEvent = null;
        for (var i = 0; i < this.events.length; i++) {
            var event_3 = this.events[i];
            if (!this.removedPolygonIds[event_3.polygonId]) {
                if (!exteriorEvent || event_3.position[0] < exteriorEvent.position[0]) {
                    exteriorEvent = event_3;
                }
            }
        }
        if (exteriorEvent) {
            var inPlane = this.getByX(exteriorEvent.position);
            if (inPlane.length > 0) {
                exteriorEvent = inPlane.sort(function (a, b) { return b.position[1] - a.position[1]; })[0];
            }
        }
        return exteriorEvent;
    };
    EventIndex.prototype.markTouchedPolygonsAsProcessed = function () {
        for (var key in this.touchedPolygonIds) {
            this.removedPolygonIds[key] = true;
            for (var touching in this.touchTable[key]) {
                this.removedPolygonIds[touching] = true;
            }
        }
        this.touchedPolygonIds = {};
    };
    EventIndex.prototype.recordTouchedPolygons = function (polygonIds) {
        for (var _i = 0, polygonIds_1 = polygonIds; _i < polygonIds_1.length; _i++) {
            var id = polygonIds_1[_i];
            this.touchedPolygonIds[id] = true;
        }
    };
    EventIndex.prototype.resetProcessedState = function () {
        this.removedPolygonIds = {};
        this.touchedPolygonIds = {};
    };
    EventIndex.prototype.getTouchedPolygonIds = function () {
        return Object.keys(this.touchedPolygonIds).map(function (k) { return parseInt(k); });
    };
    return EventIndex;
}());
exports.EventIndex = EventIndex;
